import { createActions } from 'redux-actions'

const Browsing = createActions({
  'BROWSING_SET_KIOSK': value => value,
}, 'BROWSING_NOT_FOUND', 'BROWSING_FOUND', 'BROWSING_RESET')

export default Browsing
